import CryptoJS from 'crypto-js';
import { openDB } from 'idb';

// const SECRET_KEY = 'm3dl09zp7-4th0qlja-t3r4fha';
const DB_NAME = 'QuestionDB';
const DB_VERSION = 1;

export async function initDB(tableName) {
    if (!tableName || typeof tableName !== 'string') {
        throw new Error('Invalid tableName provided to initDB.');
    }
    return openDB(DB_NAME, DB_VERSION, {
        upgrade(db) {
            // List all required tables
            const requiredTables = [
                process.env.REACT_APP_GENERAL_QUESTIONS_TB,
                process.env.REACT_APP_STATE_QUESTIONS_TB,
                // process.env.REACT_APP_TEST_QUESTIONS_TB,
                process.env.REACT_APP_STAR_QUESTIONS_TB,
            ];

            // Create tables if they do not exist
            for (const tableName of requiredTables) {
                if (!db.objectStoreNames.contains(tableName)) {
                    db.createObjectStore(tableName, { keyPath: 'id' });
                }
            }
        },
    });
}

export function encryptData(data) {
    return CryptoJS.AES.encrypt(
        JSON.stringify(data),
        process.env.REACT_APP_CRYPTOJS_SECRET_KEY,
    ).toString();
}

export function decryptData(data) {
    const bytes = CryptoJS.AES.decrypt(
        data,
        process.env.REACT_APP_CRYPTOJS_SECRET_KEY,
    );

    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
}

// Save multiple key-value pairs to a specific table
export async function saveAllToCache(tableName, items) {
    const db = await initDB(tableName);
    const tx = db.transaction(tableName, 'readwrite');
    const store = tx.objectStore(tableName);

    for (const item of items) {
        const encryptedValue = encryptData(item);
        var newItem = { id: item.id, value: encryptedValue };
        await store.put(newItem);
    }

    await tx.done;
    console.log(`Saved ${items.length} items to ${tableName}`);
}

// Save one item to indexed db
export async function saveToCache(tableName, item) {
    const db = await initDB(tableName);
    const tx = db.transaction(tableName, 'readwrite');
    const store = tx.objectStore(tableName);

    const encryptedValue = encryptData(item);
    var newItem = { id: item.id, value: encryptedValue };
    await store.put(newItem);

    await tx.done;
    console.log(`Saved ${item} to ${tableName}`);
}

// Retrieve all key-value pairs from a specific table
export async function getAllFromCache(tableName) {
    const db = await initDB(tableName);
    const tx = db.transaction(tableName, 'readonly');
    const store = tx.objectStore(tableName);

    const items = await store.getAll();
    return items.map((item) => decryptData(item.value));
}

// Retrieve a specific key-value pair from a table
export async function getFromCacheById(tableName, id) {
    const db = await initDB(tableName);
    const record = await db.get(tableName, id);
    // return record ? { ...record, value: decryptData(record.value) } : null;
    return record ? decryptData(record.value) : null;
}

// Clear all data in a specific table
export async function clearTable(tableName) {
    const db = await initDB(tableName);
    const tx = db.transaction(tableName, 'readwrite');
    await tx.objectStore(tableName).clear();
    await tx.done;
    console.log(`Cleared table: ${tableName}`);
}

// Delete the entire database
export async function deleteDatabase() {
    await indexedDB.deleteDatabase(DB_NAME);
    console.log(`Deleted database: ${DB_NAME}`);
}
